var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-icon',{attrs:{"color":_vm.colors[_vm.climbingStyle],"small":_vm.small,"left":_vm.left,"right":_vm.right}},[_vm._v("\n  "+_vm._s(_vm.icons[_vm.climbingStyle])+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }